
import { TextureSet } from './Texture';
import Renderer from './Renderer';
import { Shader, VertexShader, FragmentShader, ShaderProgram } from '../rendering/Shader';

const vertexScript = require('../visuals/shaders/vertex/copy.vert');
const fragmentScript = require('../visuals/shaders/fragment/copy.frag');

const vertexShader = new VertexShader(vertexScript, ['aVertexPosition', 'aUV'], []);
const fragmentShader = new FragmentShader(fragmentScript, [], ['uTexture']);
const shader = new Shader(vertexShader, fragmentShader);

export const debugRenderQueues = {};

const quadBuffer = new ArrayBuffer(4 * (2 * 4 + 4))
const quadBufferFloat = new Float32Array(quadBuffer);
const quadBufferLong = new Int32Array(quadBuffer);
const debugQuadBufferBinders = {};
export default function debugRender (renderer: Renderer, textureSet: TextureSet) {
	const gl = renderer.gl;
	const rendererID = renderer.id;

	let debugRenderQueue = debugRenderQueues[rendererID];
	if (debugRenderQueue === undefined) {
		debugRenderQueue = debugRenderQueues[rendererID] = [];
	}

	debugRenderQueue.push(() => {
		renderer.setupProgram(shader, textureSet.set, null);

		let quadBufferBinder = debugQuadBufferBinders[rendererID];
		if (quadBufferBinder === undefined) {
			quadBufferBinder = debugQuadBufferBinders[rendererID] = gl.createBuffer();
			gl.bindBuffer(gl.ARRAY_BUFFER, quadBufferBinder);
		}

		const program = shader.program;

		const x0 = 0.4;
		const y0 = 0.4;
		const x1 = 1;
		const y1 = 1;

		const cu0 = 0 * 0xffff     & 0xffff;
		const cu1 = 1 * 0xffff     & 0xffff;
		const cv0 = 0 * 0xffff0000 & 0xffff0000;
		const cv1 = 1 * 0xffff0000 & 0xffff0000;

		// top left
		quadBufferFloat[0] = x0;
		quadBufferFloat[1] = y0;
		quadBufferLong[2] = cu0 + cv0;

		// top right
		quadBufferFloat[3] = x1;
		quadBufferFloat[4] = y0;
		quadBufferLong[5] = cu1 + cv0;

		// bottom left
		quadBufferFloat[6] = x0;
		quadBufferFloat[7] = y1;
		quadBufferLong[8] = cu0 + cv1;

		// bottom right
		quadBufferFloat[9] = x1;
		quadBufferFloat[10] = y1;
		quadBufferLong[11] = cu1 + cv1;

		gl.depthMask(true);
		gl.disable(gl.DEPTH_TEST);
		gl.disable(gl.CULL_FACE);
		// gl.enable(gl.BLEND);
		// gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);

		gl.bindBuffer(gl.ARRAY_BUFFER, quadBufferBinder);
		
		const bytesPerVertexPosition    = 4 * 2;
		const bytesPerUV = 2 * 2;
		const totalByteSize = bytesPerVertexPosition + bytesPerUV;
		gl.vertexAttribPointer(program.attributes.aVertexPosition, 2, gl.FLOAT, false, totalByteSize, 0);
		gl.vertexAttribPointer(program.attributes.aUV, 2, gl.UNSIGNED_SHORT, true, totalByteSize, bytesPerVertexPosition);

		gl.bufferData(gl.ARRAY_BUFFER, quadBuffer, gl.DYNAMIC_DRAW);

		gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, renderer.quadIndexBuffer);
		gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0);
	});
}
